export default async () => {
	let header = $( 'header' );
	let position = $( window ).scrollTop();

	$( window ).scroll( function () {
		let scroll = $( window ).scrollTop();

		if ( $( this ).scrollTop() > 200 ) {
			if ( scroll > position ) {
				header.addClass( 'header--sticky' );
			} else {
				header.removeClass( 'header--sticky' );
			}
		}
		position = scroll;
	} );

	// Button toggle
	$( '.js-btn-toggle' ).click( function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'active' );
		$( '.header__list' ).slideToggle();
	} );

	// Mm toggle
	$( '.header__toggle' ).click( function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.header__menu' ).toggleClass( 'header__menu--open' );
		$( 'body' ).toggleClass( 'scroll-hidden' );
	} );

	// Header menu
	$( '.header__menu > ul > li > .header__dropdown, .header__menu > ul > li' ).parent( 'li' ).addClass( 'has-children' );
	$( '.header__menu > ul > .has-children > a' ).append().after( '<span class=\'header__mm-arrow hide-for-large js-menu-toggle\'><i class=\'icon-arrow-down\'></i></span>' );
	$( '.js-menu-toggle' ).click( function ( e ) {
		e.preventDefault();
		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 'slow' );
		} else {
			$this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 'slow' );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 'slow' );
		}
	} );
};
